<script> 
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";



export default {
  mixins: [apibtoast, apigeneric],
  props: ["guncelle", "satdosyaId","SecilenFirmaid"],
  data() {
    return {
      KurumBilgisi :[],
      satdosya:[],
      ihale_komisyonu: [],
      yazdirilanfirma:{},
      firma_kalemler:[],
      firma_fiyatlar:[],
      dosya_malzemeler:[],
      OnayBelgesi:{},
      ihale_usulu:"",
      alim_turu:"",
      ihaleilani:[],
      Firma_Toplam:[],
      zarfacmakontrol:{},
      gecerli_teklifler:[],
      gecersiz_teklifler:[],
      dosyafirmalar:[],
      harcamayetkilisi:{},
      katilanfirmalar:0,
      Ihalekesinlesenkararitarihi:"",
      Ihalekomisyonkararionaytarihi:"",
      Kesinteminattarihi:"",
      Ihalekomisyonkarari:"",
      zarfteslimtarih:"",
      zarfteslimsira:"",
      Ihaleyiyapanmakam:"",
      Alimturuharfi:"",

      Dosya:{},
          Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },

         uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
 

    };
  },

  components: {
    Loader

 
  },
  watch: {
    guncelle() {
      this.Get();     
    },
  },
created(){
    this.Get();
  },
  methods: {

        ExcelExport(table, name){ 
          if (!table.nodeType) table = this.$refs.KomisyonKarari
          var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
          var a = document.createElement('a');
       a.href = this.uri +this.base64(this.format(this.template, ctx));
        a.download = name + '.xls';
        a.click(); 
      }, 

      
    Get() {

          this.ActionsFilterGet({
          Service: "SatDosyaFirma",
          Page: this.Page,
          Filter: "&Dosyaid=" + this.satdosyaId ,
          }).then((res) => {

              this.dosyafirmalar=res.Data;

          });



      this.ActionsGet({"Service":"OKurumSabit", "Page":this.Page}).then((res) => {

        this.KurumBilgisi = res.Data[0];

      });

      this.ActionsGet({"Service":"SatDosya/"+this.satdosyaId, "Page":this.Page}).then((res) => {
        this.satdosya=res.Data;
              this.Ihalekesinlesenkararitarihi=res.Data.Ihalekesinlesenkararitarihi;
              this.Ihalekomisyonkararionaytarihi=res.Data.Ihalekomisyonkararionaytarihi;
              this.Kesinteminattarihi=res.Data.Kesinteminattarihi;

              this.Ihalekomisyonkarari=res.Data.Ihalekomisyonkarari;


            this.ActionsGet({"Service":"Obirim/"+res.Data.Ihaleyiyapanmakam, "Page":this.Page}).then((res2) => {
      
               this.Ihaleyiyapanmakam=res2.Data.BirimAdi;

            });


              let Alimturu=res.Data.Alimturu;

                    this.ActionsSabitGet(1548).then(res => {  
                        for(var i=0; i<res.Data.length; i++)
                        {

                          if (Alimturu==res.Data[i].Id){
                           
                              this.alim_turu=res.Data[i].Value;

                               if (this.alim_turu=="Mal")
                              {this.Alimturuharfi="M";} 
                              else if (this.alim_turu=="Hizmet"){
                                  this.Alimturuharfi="H";
                              }


                          }
                         
                        }    
                    }); 

                let ihaleusulu = res.Data.Ihaleturu;

                  this.ActionsSabitGet(1552).then(res => {  
                        for( var i=0; i<res.Data.length; i++)
                        {

                          if (ihaleusulu==res.Data[i].Id){
                           
                              this.ihale_usulu=res.Data[i].Value;
                          }
                         
                        }    
                    }); 

            });


      this.ActionsFilterGet({"Service":"SatOnayBelgesi", "Page":this.Page,"Filter":"&Dosyaid="+this.satdosyaId}).then((res) => {
        if (res.Data.length>0){
            this.OnayBelgesi = res.Data[0];
            let harcamaid=this.OnayBelgesi.Harcamaid;
           

            this.ActionsGet({"Service":"OPersonel/"+harcamaid, "Page":this.Page}).then((res2) => {
             
               this.harcamayetkilisi=res2.Data;

            });

        }
      
      });


          this.ActionsFilterGet({"Service":"SatDosyaIhaleIlani", "Page":this.Page,
      "Filter":"&Dosyaid="+this.satdosyaId}).then((res) => {
          this.ihaleilani=res.Data;
    

      });

    this.ActionsFilterGet({"Service":"SatDosyaZarfTeslim", "Page":this.Page,
      "Filter":"&Dosyaid="+this.satdosyaId}).then((res) => {
          for (var i=0 ; i< res.Data.length;i++){

            if (res.Data[i].Firmaid==this.SecilenFirmaid.firmaid)
            {
              this.zarfteslimtarih=res.Data[i].Teslimtarihsaat;
              this.zarfteslimsira=res.Data[i].Sirano;
            }

          }


    this.ActionsGet({"Service":"OFirma/"+this.SecilenFirmaid.firmaid, "Page":this.Page}).then((yazdirilan) => {
    this.yazdirilanfirma=yazdirilan.Data;

        if(this.satdosya.Teklifdegerlendirmeyontem==2){
            this.karar_tablosu();
        } else {
            this.karar_tablosu_kumulatif();
        }
                                        
     });

    

      });


     
    }, 

    karar_tablosu(){

      this.firma_kalemler=[];

      this.ActionsFilterGet({"Service":"SatDosyaFirmaFiyat/GetEkonomikFiyat", "Page":this.Page,
      "Filter":"&Dosyaid="+this.satdosyaId+"&TeklifDegerlendirmeYontem=2"}).then((res) => {
          if(res){

            this.dosya_malzemeler=res.Data.BirimFiyat.Ekonomikgrid;

              let tutar=0;

            
              for (var i=0; i<this.dosya_malzemeler.length; i++){

                 if( this.yazdirilanfirma.Firmaadi==this.dosya_malzemeler[i].Kazananfirmaadi){

                    tutar=tutar+this.dosya_malzemeler[i].Tutar;
                 }               

              }

               this.firma_kalemler.push({Tutar:tutar});


          }
    

      });


    },

    karar_tablosu_kumulatif(){

      this.firma_kalemler=[];

      this.ActionsFilterGet({"Service":"SatDosyaFirmaFiyat/GetEkonomikFiyat", "Page":this.Page,
      "Filter":"&Dosyaid="+this.satdosyaId+"&TeklifDegerlendirmeYontem=1"}).then((res) => {
          if(res){

            this.ihale_fiyatlar=res.Data.GoturuBedel.IstekliList;

             for (var i=0; i<this.ihale_fiyatlar.length; i++){

                 if( this.yazdirilanfirma.Firmaadi==this.ihale_fiyatlar[i].Firmaadi){

                   this.firma_kalemler.push({Tutar:this.ihale_fiyatlar[i].Tutar});

                 }               

              }

               


          }
    

      });

    },


    
Export2Word(element, filename = 'sözlesmeye davet'){
    var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
    var postHtml = "</body></html>";
    var html = preHtml+document.getElementById(element).innerHTML+postHtml;

    var blob = new Blob(['\ufeff', html], {
        type: 'application/msword'
    });
    
    // Specify link url
    var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
    
    // Specify file name
    filename = filename?filename+'.doc':'document.doc';
    
    // Create download link element
    var downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);
    
    if(navigator.msSaveOrOpenBlob ){
        navigator.msSaveOrOpenBlob(blob, filename);
    }else{
        // Create a link to the file
        downloadLink.href = url;
        
        // Setting the file name
        downloadLink.download = filename;
        
        //triggering the function
        downloadLink.click();
    }
    
    document.body.removeChild(downloadLink);
},

    tlCevir(sayi)
        {
            var rakam = sayi.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".").split(",");
            var tamsayi = rakam[0];
            var ondalik = rakam[1]||"";



            var birler = ["","BİR","İKİ","ÜÇ","DÖRT","BEŞ","ALTI","YEDİ","SEKİZ","DOKUZ"];
            var onlar = ["","ON","YİRMİ","OTUZ","KIRK","ELLİ","ALTMIŞ","YETMİŞ","SEKSEN","DOKSAN"];
            var binler = ["","BİN","MİLYON","MİLYAR","TRİLYON","KATRİLYON","KENTİLYON"];
            var sonuc = [];

            var adim = 0;
            for(var i=tamsayi.split(".").length;i>0;i--)
            {
                sayi = tamsayi.split(".")[i-1];
                if(sayi.length==1){ sayi="00"+sayi; }
                if(sayi.length==2){ sayi="0"+sayi; }
                var c="";

                for(var j=1;j<sayi.length+1;j++)
                {
                    if(j==1 && sayi[j-1]==1){ c+= " YÜZ "; }
                    else if(j==1 && birler[sayi[j-1]]!=""){ c+= birler[sayi[j-1]]+" YÜZ "; }
                    else if(j==2){ c+= onlar[sayi[j-1]]+" "; }
                    else if(j==3 && tamsayi.length==5 && sayi[j-1]==1 && adim==1){ c+= " "; }
                    else if(j==3){ c+= birler[sayi[j-1]]+" "; }
                }

                if(c!=""){ sonuc.push(c+binler[adim]); }
                adim++;
            }

            if(sonuc.length!=0){ sonuc = sonuc.reverse().join(" "); }else{ sonuc=""; }
            if(ondalik.length==1){ ondalik=ondalik+"0"; }
            if(ondalik!=""){
                sonuc += " "+onlar[ondalik[0]]+" "+birler[ondalik[1]]+ " KR";
            }

            sonuc = sonuc.replace(/ /g," ").trim();

            return sonuc;
        },

     
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="sozlesmeyedavet"
      size="lg"
      title="Sözleşmeye Davet"
      title-class="font-18"
      hide-footer
    >  

              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
     
                    <button
                      type="button"
                      class="btn btn-warning btn-rounded mb-2 me-2"
                     @click="Export2Word('exportContent')"
                    >
                      <i class="mdi mdi-file-export-outline me-1"></i>
                     Word'e Aktar
                    </button>
                  </div>
                </div>
              </div>

          
<div id="exportContent" class="a4_dikey"  style="margin-left:10px; " >
   
<center><strong>TC</strong></center>
<center><strong>{{KurumBilgisi.Kurumadi}}</strong></center>
<center><strong>{{Ihaleyiyapanmakam}}</strong></center>
<br>
 <div style=" margin: 5px" class="table-responsive">
   <table style="width: 95%;">
<tbody>
  <tr>
<td style="width: 223px;">&nbsp;Sayı</td>
<td style="width: 10px;">:</td>
<td style="width: 263.837px;">&nbsp;1</td>
<td>
  <p style="text-align: right;">{{Ihalekesinlesenkararitarihi | formatDateTable }}</p>
</td>
</tr>
<tr>
<td style="width: 223px;">&nbsp;Konu</td>
<td style="width: 10px;">:</td>
<td colspan="2" style="width: 263.837px;">Sözleşmeye Davet</td>

</tr>
</tbody>
   </table>
 </div>
<br>
 <div style=" margin: 15px" class="table-responsive">


<table style="width: 95%;">
<tbody>

<tr>
<td style="width: 223px;">&nbsp;İhale kayıt numarası&nbsp;</td>
<td style="width: 10px;">:</td>
<td style="width: 263.837px;">{{ihaleilani[0].Ihalekayitnumarasi}}</td>
</tr>
<tr>
<td style="width: 223px;">&nbsp;İhalenin kararının onaylandığı Tarih</td>
<td style="width: 10px;">:</td>
<td style="width: 263.837px;">{{Ihalekomisyonkararionaytarihi | formatDateTime }}</td>
</tr>
</tbody>
</table>

  </div>

<p>Bu mektup {{Ihalekesinlesenkararitarihi | formatDateTime }} tarihinde tarafınıza EKAP Üzerinden gönderilmiştir.</p>

<p>Sayın {{yazdirilanfirma.Firmaadi}}<br>
{{yazdirilanfirma.Firmaadresi}}<br>


 <div style="margin:10px; ">
<p>İLGİ : {{zarfteslimtarih | formatDateTable}} tarihinde, {{zarfteslimsira}} sıra numarası ile kayda alınan teklifiniz</p>

<p><strong> {{OnayBelgesi.Isintanimi}} </strong> işine ait ihalede uhdenizde kalan kısımlar ekteki listede belirtilmiştir. 
Tebliğ tarihini izleyen günden itibaren en geç on gün içinde ihale tarihinde 4734 sayılı 
Kanunun 10 uncu maddesinin dördüncü fıkrasının (a), (b), (c), (d), (e) ve (g) bentlerinde sayılan durumlarda olmadığınıza 
dair belgeleri vermek ve diğer yasal yükümlülükleri yerine getirmek suretiyle ihale konusu işe ilişkin sözleşmeyi imzalamanız 
gerekmektedir.
Bu mektubun EKAP üzerinden bildirilmesi halinde bildirim tarihi, tebliğ tarihi sayılacaktır.
Bilgileri ve gereğini rica ederim.
</p>


    </div>


<div style="margin-left:10px;">

  <div class="row">
    <div class="col-md-6">
    </div>
    <div class="col-md-6">
        <p style="text-align: center;">
          {{harcamayetkilisi.Adsoyad}}<br>
        {{harcamayetkilisi.Unvanadi}}</p>
    </div>
 </div>

<br>

 <div v-if="satdosya.Teklifdegerlendirmeyontem==1" style=" margin: 10px" class="table-responsive">
   <table   style="border: 1px solid; border-collapse: collapse; width: 95%;" border="1" class="table  table-sm table-bordered border-success mb-0" >
      <tbody>
        <tr>
          <th>İHALE TUTARI:</th> <th><p style="text-align: right;">{{firma_kalemler[0].Tutar | TrParaFormat}} TL</p></th> <th></th>
        </tr>
        <tr>
          <td>TAHAKKUK EDEN (KDV HARİÇ) :</td><td><p style="text-align: right;">{{firma_kalemler[0].Tutar | TrParaFormat}} TL</p></td><td></td>
        </tr>
        <tr>
          <td>İHALE KARARLARINA AİT DAMGA VERGİSİ (0,569)</td>
          <td><p style="text-align: right;">{{(firma_kalemler[0].Tutar*0.569)/100 | TrParaFormat}} TL</p></td>
          <td width="150"><center>Firmanın Maliyeye yatıracağı miktar</center></td>
        </tr>
        <tr>
          <td>SÖZLEŞMEYE AİT DAMGA VERGİSİ (0,948)</td>
          <td><p style="text-align: right;">{{(firma_kalemler[0].Tutar*0.948)/100 | TrParaFormat}} TL</p></td>
          <td><center>Firmanın Maliyeye yatıracağı miktar</center></td>
        </tr>
        <tr>
          <td rowspan="2">KESİN TEMİNAT </td>
      
          <td>SÜRESİ (EN AZ) </td><td><p style="text-align: right;">{{Kesinteminattarihi | formatDateTable}}</p></td>
        </tr>
        <tr>
          <td>MİKTARI (EN AZ)</td><td><p style="text-align: right;">{{(firma_kalemler[0].Tutar*6)/100 | TrParaFormat}} TL</p></td>
        </tr>
      </tbody>
   </table>
 </div>

 <div v-if="satdosya.Teklifdegerlendirmeyontem==2" style=" margin: 10px" class="table-responsive">
   <table  style="border: 1px solid; border-collapse: collapse; width: 95%;" border="1" class="table  table-sm table-bordered border-success mb-0" >
      <tbody>
        <tr>
          <th>İHALE TUTARI:</th> <th><p style="text-align: right;">{{firma_kalemler[0].Tutar | TrParaFormat}} TL</p></th> <th></th>
        </tr>
        <tr>
          <td>TAHAKKUK EDEN (KDV HARİÇ) :</td><td><p style="text-align: right;">{{firma_kalemler[0].Tutar | TrParaFormat}} TL</p></td><td></td>
        </tr>
        <tr>
          <td>İHALE KARARLARINA AİT DAMGA VERGİSİ (0,569)</td>
          <td><p style="text-align: right;">{{(firma_kalemler[0].Tutar*0.569)/100 | TrParaFormat}} TL</p></td>
          <td width="150"><center>Firmanın Maliyeye yatıracağı miktar</center></td>
        </tr>
        <tr>
          <td>SÖZLEŞMEYE AİT DAMGA VERGİSİ (0,948)</td>
          <td><p style="text-align: right;">{{(firma_kalemler[0].Tutar*0.948)/100 | TrParaFormat}} TL</p></td>
          <td><center>Firmanın Maliyeye yatıracağı miktar</center></td>
        </tr>
        <tr>
          <td rowspan="2">KESİN TEMİNAT </td>
      
          <td>SÜRESİ (EN AZ) </td><td><p style="text-align: right;">{{Kesinteminattarihi | formatDateTable}}</p></td>
        </tr>
        <tr>
          <td>MİKTARI (EN AZ)</td><td><p style="text-align: right;">{{(firma_kalemler[0].Tutar*6)/100 | TrParaFormat}} TL</p></td>
        </tr>
      </tbody>
   </table>
 </div>

<br>


<footer> 
<p style="text-align: right;">Standart Form ― KİK021.0/{{Alimturuharfi}}<br>
Sözleşmeye Davet</p>
</footer>

</div>

  </div>
         




    </b-modal>
  </Loader>
</template>

<style>

 .a4_dikey {

	width: 20.5cm;
	height: 29cm;
	position: relative;
}
.a4_dikey footer {
	position: absolute;
	bottom: 10px;
	right: 25px;
}

.yazi{

   font-family: Arial, Helvetica, sans-serif;
   font-size: 12px; 
   line-height: 15px;
   
}
    
</style>